import { mdiCheck, mdiClose, mdiPencil, mdiDelete, mdiPlus } from "@mdi/js";
import Icon from "@mdi/react";
import { FunctionComponent } from "react";

interface LineItemActionsProps {
  isAddRow: boolean;
  editable: boolean;
  canAdd: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  onDelete: () => void;
}

const chip =
  "flex items-center gap-1 px-3 py-1 rounded-full text-xs cursor-pointer hover:scale-105 transform duration-200";

/** Context actions: Add on the new row; Edit/Save/Cancel + Delete on existing. */
const LineItemActions: FunctionComponent<LineItemActionsProps> = ({
  isAddRow,
  editable,
  canAdd,
  onEdit,
  onSave,
  onCancel,
  onDelete,
}) => {
  if (isAddRow) {
    return (
      <button
        disabled={!canAdd}
        className="flex gap-1 items-center text-white text-xs bg-myPrimaryColor rounded-full px-3 py-1"
      >
        <Icon path={mdiPlus} className="h-4 w-4" /> Add
      </button>
    );
  }

  return (
    <>
      {editable ? (
        <>
          <div
            onClick={() => {
              if (!window.confirm("Are you sure !")) return;
              onSave();
            }}
            className={`${chip} bg-myPrimaryColor text-white`}
          >
            <Icon path={mdiCheck} className="h-4 w-4" /> Save
          </div>
          <div
            onClick={onCancel}
            className={`${chip} bg-gray-100 text-gray-700`}
          >
            <Icon path={mdiClose} className="h-4 w-4" /> Cancel
          </div>
        </>
      ) : (
        <div onClick={onEdit} className={`${chip} bg-gray-100 text-gray-700`}>
          <Icon path={mdiPencil} className="h-4 w-4" /> Edit
        </div>
      )}
      <div
        onClick={() => {
          if (!window.confirm("Are you sure !")) return;
          onDelete();
        }}
        className={`${chip} bg-red-100 text-red-700`}
      >
        <Icon path={mdiDelete} className="h-4 w-4" /> Delete
      </div>
    </>
  );
};

export default LineItemActions;
